export const productIfuFields = ['instructionsForUse', 'name'];
